import { useMemo } from 'react';
import { Box, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { renderTemplatePreview } from 'legacy/TemplatePreview/helpers';
import { useIsMdBreakpoint } from 'hooks';
import { Page } from './Page';

export type DocumentStepProps = {
  template?: {
    contractTemplate: object;
  };
  onSubmit: () => void;
};

export const DocumentStep: React.FC<DocumentStepProps> = ({
  template,
  onSubmit,
}) => {
  const isMdBreakpoint = useIsMdBreakpoint();
  const nestedPath = 'contractValues';
  const { t } = useTranslation();
  const contractTemplate = template?.contractTemplate!;
  const preview = useMemo(
    () => renderTemplatePreview(contractTemplate, nestedPath),
    [contractTemplate],
  );

  const {
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();

  const onClick = async () => {
    const isValid = await trigger(nestedPath, { shouldFocus: true });
    if (isValid) {
      onSubmit();
    } else {
      // eslint-disable-next-line no-console
      console.debug({
        values: watch(),
        errors,
      });
    }
  };

  const stepperHeight = isMdBreakpoint ? 42 : 64;

  return (
    <>
      <Page
        sx={{
          position: 'sticky',
          zIndex: 2,
          top: 24 + stepperHeight + 24,
        }}
      >
        <Box
          sx={theme => ({
            borderTop: `1px solid ${theme.colors.gray[2]}`,
          })}
        />
      </Page>
      <Page>
        <Box
          p={8}
          sx={theme => ({
            borderLeft: `1px solid ${theme.colors.gray[2]}`,
            borderRight: `1px solid ${theme.colors.gray[2]}`,
            overflow: 'auto',
            height: '100%',
            width: '100%',
            position: 'relative',
          })}
        >
          {preview}
        </Box>
      </Page>
      <Page
        sx={{
          position: 'sticky',
          zIndex: 2,
          bottom: 16 + 36 + 16,
        }}
      >
        <Box
          sx={theme => ({
            borderTop: `1px solid ${theme.colors.gray[2]}`,
          })}
        />
      </Page>
      <Page py={16} sx={{ position: 'sticky', zIndex: 2, bottom: 0 }}>
        <Box
          sx={theme => ({
            display: 'flex',
            columnGap: theme.spacing.sm,
            justifyContent: isMdBreakpoint ? 'flex-end' : 'center',
          })}
        >
          <Button onClick={onClick}>{t('common:next')}</Button>
        </Box>
      </Page>
    </>
  );
};
